import 'reflect-metadata';
import { Convertible, asSmartDBEntity, getAssetsFromCS, hexToStr, isNullOrBlank } from '../Commons/index';
import { BaseSmartDBEntity } from './index.exports';

@asSmartDBEntity()
export class FundHoldingEntity extends BaseSmartDBEntity {
    protected static _apiRoute: string = 'fundholdings';
    protected static _className: string = 'Fund Holding';
    // protected static _mongoTableName: string = 'Fund Holding';

    protected static _plutusDataIndex = 0;

    // #region fields

    @Convertible({ isCreatedAt: true })
    createdAt!: Date;

    @Convertible({ isUpdatedAt: true })
    updatedAt!: Date;

    // #endregion fields

    // #region datum

    @Convertible({ isForDatum: true })
    hdVersion!: number;

    @Convertible({ isForDatum: true })
    hdFundHolding_Index!: number;

    @Convertible({ isForDatum: true })
    hdSubtotal_FT_Minted_Accumulated!: bigint;

    @Convertible({ isForDatum: true })
    hdSubtotal_FT_Minted!: bigint;

    @Convertible({ isForDatum: true })
    hdSubtotal_FT_Commissions!: bigint;

    @Convertible({ isForDatum: true })
    hdSubtotal_FT_Commissions_Total!: bigint;

    @Convertible({ isForDatum: true })
    hdSubtotal_FT_Commissions_Release_PerMonth_1e6!: bigint;

    @Convertible({ isForDatum: true })
    hdSubtotal_FT_Commissions_Collected_Protocol!: bigint;

    @Convertible({ isForDatum: true })
    hdSubtotal_FT_Commissions_Collected_Managers!: bigint;

    @Convertible({ isForDatum: true })
    hdSubtotal_FT_Commissions_Collected_Delegators!: bigint;

    @Convertible({ isForDatum: true })
    hdMinADA!: bigint;

    // #endregion datum

    // #region  db

    public static defaultFieldsWhenUndefined: Record<string, boolean> = {};

    public static alwaysFieldsForSelect: Record<string, boolean> = {
        ...super.alwaysFieldsForSelect,
        hdSubtotal_FT_Minted: true,
        hdSubtotal_FT_Commissions: true,
        hdSubtotal_FT_Commissions_Total: true,
        hdMinADA: true,
    };

    // #endregion  db

    // #region class methods

    public getNET_id_TN_Str(): string {
        if (isNullOrBlank(super.getNET_id_TN_Str()) === false) return super.getNET_id_TN_Str();
        if (this.smartUTxO !== undefined) {
            const assetsCS = getAssetsFromCS(this.smartUTxO?.assets, this.getNET_id_CS());
            const pid = Object.keys(assetsCS);
            if (pid.length === 1) {
                const TN_Str = hexToStr(pid[0].slice(56));
                return TN_Str;
            }
        }
        return '';
    }

    // #endregion class methods
}
